import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart2",
  "use": "heart2-usage",
  "viewBox": "0 0 30 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 30 26\" id=\"heart2\"><path fill=\"#EF5B25\" d=\"M21.038.25a7.833 7.833 0 0 0-6.51 3.42C13.08 1.63 10.712.25 8.016.25 3.677.25.125 3.801.125 8.142c0 9.14 10.062 17.033 14.468 17.033 4.406 0 14.468-7.958 14.468-17.033C28.995 3.802 25.444.25 21.038.25Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol